import "./App.css";
import Root from "./routes/root";
import 'bootstrap/dist/css/bootstrap.min.css'

function App() {
  return (
    <div className="App">
      <Root />
    </div>
  );
}

export default App;
